export default function (type) {
    if ("CREATION" === type) {
        return "Création"
    } else if ("INSCRIPTION" === type || "FUSION_ABSORPTION" === type) {
        return "Inscription"
    } else if ("RECTIFICATION" === type) {
        return "Rectification"
    } else if ("DOCUMENTS" === type) {
        return "Documents"
    } else if ("INSTANTANE" === type) {
        return "Instantanée"
    } else if ("REPRISE" === type || "CREATION_REPRISE" === type) {
        return "Reprise du registre papier"
    }
    return null;
}
